import { AcceptTermsModal } from "./AcceptTermsModal";
export default AcceptTermsModal;
